export default function LowerBidder({ difference, children, ...rest }) {
  return (
    <div {...rest}>
      <span>
        You were outbid by{' '}
        {Number(difference).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </span>

      <style jsx>{`
        div {
          display: inline-block;
          background: var(--alert-color);
          color: #fff;
          white-space: nowrap;
          font-weight: 700;
        }
      `}</style>

      <style jsx>{`
        div {
          padding: 0.8rem 1.3rem;
          border-radius: 1.8rem;
          font-size: 1.4rem;
        }
      `}</style>
    </div>
  )
}
